import { supabase } from '../lib/supabaseClient';

export async function checkUserData() {
  console.log('🔍 Checking user data consistency...');
  
  try {
    // Get all profiles
    const { data: profiles, error: profilesError } = await supabase
      .from('profiles')
      .select('id, email, full_name, role, created_at')
      .order('created_at', { ascending: false });
    
    if (profilesError) {
      console.error('❌ Error fetching profiles:', profilesError);
      return;
    }
    
    console.log('📊 Total profiles in database:', profiles?.length || 0);
    console.log('👥 All profiles:');
    profiles?.forEach((profile, index) => {
      console.log(`${index + 1}. ID: ${profile.id}`);
      console.log(`   Email: ${profile.email}`);
      console.log(`   Name: ${profile.full_name || 'N/A'}`);
      console.log(`   Role: ${profile.role || 'N/A'}`);
      console.log(`   Created: ${profile.created_at}`);
      console.log('   ---');
    });
    
    // Check for duplicate emails
    const emailCounts = new Map();
    profiles?.forEach((profile: any) => {
      if (profile.email) {
        const count = emailCounts.get(profile.email) || 0;
        emailCounts.set(profile.email, count + 1);
      }
    });
    
    const duplicateEmails = Array.from(emailCounts.entries()).filter(([_, count]) => count > 1);
    if (duplicateEmails.length > 0) {
      console.log('⚠️  Duplicate emails found:');
      duplicateEmails.forEach(([email, count]) => {
        console.log(`   ${email}: ${count} occurrences`);
      });
    } else {
      console.log('✅ No duplicate emails found');
    }
    
    // Get unique users by email
    const uniqueUsers = new Map();
    profiles?.forEach((profile: any) => {
      if (profile.email && !uniqueUsers.has(profile.email)) {
        uniqueUsers.set(profile.email, profile);
      }
    });
    
    console.log('🎯 Unique users by email:', uniqueUsers.size);
    console.log('📧 Unique emails:');
    Array.from(uniqueUsers.values()).forEach((user: any, index: number) => {
      console.log(`${index + 1}. ${user.email} (${user.role || 'user'})`);
    });
    
  } catch (error) {
    console.error('❌ Error checking user data:', error);
  }
}

// Function to run the check (can be called from browser console)
(window as any).checkUserData = checkUserData;